import React from 'react';
import { usePlaytesterStore } from '../../stores/playtester-store.js';

export function HordePhaseIndicator() {
  const horde = usePlaytesterStore((s) => s.horde);

  if (!horde) return null;

  let text: string;
  let colorClass: string;

  if (horde.phase === 'setup') {
    text = `Setup Turn ${horde.setupTurn} of 3 — Horde does not act this turn`;
    colorClass = 'text-blue-300 bg-blue-950/30 border-blue-800/60';
  } else if (horde.phase === 'player-turn') {
    text = 'Your Turn';
    colorClass = 'text-green-300 bg-green-950/30 border-green-800/60';
  } else {
    text = 'Horde Turn — Drag revealed cards to horde zones';
    colorClass = 'text-amber-300 bg-amber-950/30 border-amber-800/60';
  }

  return (
    <div className={`rounded border px-3 py-1.5 text-sm font-medium ${colorClass}`}>
      {text}
    </div>
  );
}
